export default __webpack_public_path__ + "static/media/error.36c0c559.png";